<template>
    <div class="footer">
        <div class="name">
            <strong>Copyright</strong> 恒石科技 1.0 &copy; 2019
        </div>
    </div>
</template>

<script>
/* eslint-disable */

export default {
    data () {
        return {}
    },
    inject: ['reload'],
    mounted () {

    },
    methods: {

    }
}
</script>

<style lang="scss">
    .footer{
        // padding: 10px;
        background-color: #1e1e1e;
        color: #686869;
        width: 100%;
        z-index: 1000;
        .footer-content{
            width: 70%;
            margin: 0 auto !important;
        }
        h3{
            padding: 5px;
        }
        p{
            padding: 3px;
            font-size: 13px;
        }
        p:hover{
            cursor: pointer;
            color: #fff;
        }
        .name{
            padding: 10px;
            font-size: 13px;
        }
    }
</style>
